module.exports = ".loan2 .row1 .col-md-2{\r\n    padding:0px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/accountmaster/loan-sanction/loan-sanction.component.css
// module id = ./src/app/accountmaster/loan-sanction/loan-sanction.component.css
// module chunks = main